import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-right"><path d="M4.75 19.25V4.75L19.25 12L4.75 19.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconArrowTriangleRight;
